<template>
  <span>
    <v-navigation-drawer
      app
      v-model="drawer"
      color="#424242"
      dark
      disable-resize-watcher
    >
      <v-list>
        <!-- create list of items, and link them to appropriate view-->

        <router-link to="/resume">
          <v-list-tile class="link" @click="$vuetify.goTo('#more')">
            <v-list-tile-content>
              Resume
            </v-list-tile-content>
          </v-list-tile>
        </router-link>

        <v-divider></v-divider>

        <router-link to="/projects">
          <v-list-tile class="link" @click="$vuetify.goTo('#more')">
            <v-list-tile-content>
              Projects
            </v-list-tile-content>
          </v-list-tile>
        </router-link>

        <v-divider></v-divider>

        <router-link to="/contact">
          <v-list-tile class="link" @click="$vuetify.goTo('#more')">
            <v-list-tile-content>
              Contact
            </v-list-tile-content>
          </v-list-tile>
        </router-link>

        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>

    <!--navigation bar for regular sized (med and up) displays-->
    <v-app-bar app dense color="#424242" dark>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer">
      </v-app-bar-nav-icon>

      <!-- make toolbar title a link to return to home page-->
      <router-link to="/">
        <v-toolbar-title class="link mr-3" to="/">{{
          appTitle
        }}</v-toolbar-title>
      </router-link>
      <hr width="1" size="40" />
      <v-btn
        depressed
        color="#424242"
        class="link hidden-sm-and-down"
        to="/resume"
        >Resume</v-btn
      >
      <v-btn
        depressed
        color="#424242"
        class="link hidden-sm-and-down"
        to="/projects"
        >Projects</v-btn
      >
      <v-btn
        depressed
        color="#424242"
        class="link hidden-sm-and-down"
        to="/contact"
        >Contact</v-btn
      >
    </v-app-bar>
  </span>
</template>

<script>
export default {
  name: "AppNavigation",
  data() {
    return {
      appTitle: "Damon Bonner",
      drawer: false,
      elements: [
        { title: "Resume" },
        { title: "Projects" },
        { title: "Contact" }
      ]
    };
  }
};
</script>

<style scoped></style>
